// extracted by mini-css-extract-plugin
export var readonly = "_ee-1";
export var star = "_ee-0";